module.exports = __webpack_public_path__ + "img/introduce.b2eee7f4.png";